import React from 'react';

const PrivacyPolicy = {
    version: '1.0.0',
    element: (
        <div className={'py-1'} data-testid="privacy-notice">
            <p className={'py-1 text-xs text-gray-600'}>
                Effective Date: Dec 8, 2025
            </p>
            <div className="font-bold py-3 text-lg">
                Canada ICP Personal Data Privacy Notice
            </div>
            <p>
                This Canada ICP Personal Data Privacy Notice (“Privacy Notice”)
                is applicable to individuals located in Canada who have been
                invited to participate in the D. E. Shaw group’s Industry
                Consultant Program (the “ICP”) (“you”). The purpose of this
                Privacy Notice is to inform you about how the D. E. Shaw group
                processes your Personal Information as defined below.
            </p>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>
                    What Information Do We Collect?
                </p>
                <div className={'pl-2'}>
                    <p className={'py-1'}>
                        “Personal Information” has the meaning assigned to it
                        under applicable Canadian laws and generally refers to
                        any information that, alone or in combination with other
                        information, is linked or can be linked to an
                        identifiable individual.
                    </p>
                    <ul className={'py-1'}>
                        We may collect some or all of the following information
                        about you:
                        <li className={'pl-4'}>
                            &#9679; Name, home address, business address, and
                            contact details, including email address and
                            telephone number;
                            <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Information you provided during the
                            engagement process, including details of your
                            qualifications, skills, experience, current
                            employment, and employment history, as well as
                            responses to oversight or screening questions and
                            any sample work product provided by you; <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Payment information including your agreed
                            compensation rate, financial account details, and
                            Tax ID;
                            <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Recordings of telephone calls with D.E. Shaw
                            group business unit members; and
                            <br />
                        </li>
                        <li className={'pl-4'}>
                            &#9679; Any other information that you voluntarily
                            provide to us.
                            <br />
                        </li>
                    </ul>
                    <p className={'py-1'}>
                        We may also collect Personal Information about you to
                        perform a periodic background check to ensure your
                        ongoing fitness and propriety to participate in the ICP.
                        When we perform such background checks, this may involve
                        the processing of data relating to criminal convictions
                        and offences, which we will process in accordance with
                        this Privacy Notice and applicable law.
                    </p>
                    <p className={'py-1'}>
                        Some of your Personal Information (as set out above)
                        will be collected from publicly available sources, such
                        as professional social media page (e.g., LinkedIn) or
                        paid information services (e.g., Zoom Info).
                        Consultations conducted by telephone may be monitored or
                        recorded in accordance with applicable regulatory
                        requirements. We may also collect information related to
                        call details (e.g., dates and times of consultations),
                        performance details (e.g., feedback from staff about the
                        quality of a consultation), and reasons for not or no
                        longer engaging with you, where applicable.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>
                    Why Do We Process Your Personal Information?{' '}
                </p>
                <div className={'pl-2'}>
                    <p className={'py-1'}>
                        The provision of certain Personal Information by you is
                        necessary in order for us to:
                        <br />
                        (a) perform our obligations under the ICP contract with
                        you;
                        <br />
                        (b) fulfil our legal and regulatory obligations; or
                        <br />
                        (c) execute other tasks related to our relationship with
                        you that are consistent with the purposes set out below.
                        <br />
                    </p>
                    <ul className={'py-1'}>
                        Processing your data allows us to:
                        <li className={'pl-4'}>
                            &#9679; identify potential consultants for the ICP;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; conduct ICP consultations to inform our
                            investment research activities;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; ensure compliance with MiFID II and other
                            legal compliance reasons;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; administer payment of remuneration in
                            connection with the ICP;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; perform audits and investigate and resolve
                            complaints, grievances, or misconduct;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; prepare for and act in relation to
                            enquiries, investigations, or proceedings by
                            governmental, administrative, judicial or regulatory
                            authorities, including civil litigation;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; monitor communications with engaged
                            consultants where monitoring is conducted in
                            accordance with D. E. Shaw group policies and
                            procedures and applicable laws;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; exercise rights set out in our ICP contract
                            with you or arising under law;
                        </li>
                        <li className={'pl-4'}>
                            &#9679; provide reasonable diligence material to a
                            third party or meet any disclosure obligations as
                            required by law in connection with a potential asset
                            or stock acquisition of a D. E. Shaw group entity,
                            or the outsourcing or insourcing of services
                            provided by employees; and{' '}
                        </li>
                        <li className={'pl-4'}>
                            &#9679; any other purposes relating to the above
                            with your consent or as otherwise permitted under
                            applicable law
                        </li>
                    </ul>
                    <p className={'py-1'}>
                        When we conduct a background check we may collect
                        information from you or use a third party data service.
                        Those services access information published by
                        government authorities, as well as information available
                        both in the public domain and from proprietary news and
                        related sources. This could result in the processing of
                        information about criminal convictions or offences.
                        Irrespective of whether we obtain such data from you or
                        from a third party, we will process it solely for the
                        limited purposes described above and as authorized by
                        law. We may process your Personal Information such as
                        your publicly available data (e.g., your name, place of
                        residence, other information that is publicly available
                        about you in the context of our screenings) using
                        artificial intelligence tools (AI) to improve or support
                        the efficiency and speed of our business processes,
                        including for screening, and in accordance with law. The
                        AI we use is a generative AI system which ingests
                        publicly available data about you to put together
                        reports. We do not conduct any automated
                        decision-making, with or without the use of AI, and the
                        output of any AI we use is being carefully reviewed and
                        validated by a human.
                    </p>
                    <p className={'py-1'}>
                        Failure to provide Personal Information in whole or in
                        part could make it impossible for us to fulfil some or
                        all of our obligations regarding the ICP, or could
                        prevent us from engaging with you.
                    </p>
                    <p className={'py-1'}>
                        Unless you give your explicit consent to do so, we will
                        not use your Personal Information for the purpose of
                        direct marketing of our services or third-party products
                        to you.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>
                    Who Has Access To Your Personal Information?
                </p>
                <div className={'pl-2'}>
                    <p className={'py-1'}>
                        We may disclose your Personal Information for the
                        purposes described above to the following recipients:
                        (i) our affiliates, service providers (e.g., IT service
                        providers, background check service providers) and
                        advisors; (ii) law enforcement agencies; (iii) courts,
                        governmental and non-governmental regulators and
                        ombudsmen; (iv) any third party that acquires, or is
                        interested in acquiring or securitizing, all or part of
                        our assets, shares, partnership interests, and/or
                        membership interests, or that succeeds us in carrying on
                        all or a part of our businesses, or services provided to
                        it, whether by merger, acquisition, reorganization or
                        otherwise; (v) as required or permitted by law,
                        including to comply with a subpoena or similar legal,
                        regulatory, or governmental request or process, or (vi)
                        when we believe in good faith that disclosure is
                        consistent with the original purpose for which the
                        Personal Information was collected, or where necessary
                        to protect our rights and property.
                    </p>
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>
                    For How Long Do We Keep Your Data?
                </p>
                <div className={'pl-2'}>
                    Except as otherwise permitted or required by applicable law
                    or regulation, we will only retain your Personal Information
                    for as long as necessary to fulfil the purposes we collected
                    it for, including for the purposes of the engagement, and
                    satisfying any legal, accounting, or reporting
                    requirements.The criteria used to determine the retention
                    periods include: (i) how long the Personal Information is
                    needed in connection with the engagement-related activities;
                    (ii) the type of Personal Information collected; and (iii)
                    whether we are subject to a legal, contractual or similar
                    obligation to retain the data (e.g., mandatory data
                    retention laws, government orders to preserve data relevant
                    to an investigation, or data that must be retained for the
                    purposes of litigation or disputes). If you would like more
                    information about applicable data retention policies, please
                    contact us using the contact details provided below.
                </div>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>Your Rights</p>
                <p className={'py-1'}>
                    You may request access to the Personal Information we hold
                    about you. Applicable law may allow or require us to refuse
                    to provide you with access to some or all of the Personal
                    Information that we hold about you, or we may have
                    destroyed, erased, or made your Personal Information
                    anonymous in accordance with our record retention
                    obligations, practices and applicable law. If we cannot
                    provide you with access to your Personal Information, we
                    will inform you of the reasons why, subject to any legal or
                    regulatory restrictions. We may charge you a fee to access
                    your Personal Information, however, we will notify you of
                    any fee in advance.
                </p>
                <p className={'py-1'}>
                    It is important that the Personal Information we hold about
                    you is accurate and up-to-date. Please keep us informed if
                    your Personal Information changes, such as if your residence
                    change. You may request that we correct inaccuracies in your
                    Personal Information, taking into account the nature of the
                    Personal Information and our purposes for processing it. We
                    may not accommodate a request to change information if we
                    believe the change would violate any law or legal
                    requirement or cause the information to be incorrect. Please
                    contact us using the contact details provided below if you
                    want to review, verify or correct your Personal Information.
                </p>
                <p className={'py-1'}>
                    Where you have provided your consent to the collection, use
                    and disclosure of your Personal Information for a specific
                    purpose, you may have the right to withdraw your consent
                    under certain circumstances. To withdraw your consent, if
                    applicable, contact us using the contact details provided
                    below. Please note that the withdrawal of consent may affect
                    our ability to facilitate your participation in the ICP
                    program and to fulfil the other purposes described above.
                </p>
                <p className={'py-1'}>
                    You may withdraw your consent to the collection, use and
                    disclosure of your Personal Information in accordance
                    applicable laws by contacting us using the contact details
                    provided below. Upon receiving your consent withdrawal, we
                    will process your request in accordance with applicable law.
                </p>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>Data Protection</p>
                <p className={'py-1'}>
                    We have implemented reasonable physical, technical and
                    organizational security measures designed to help secure
                    your Personal Information against accidental loss and
                    unauthorized access, use, alteration or disclosure. While we
                    attempt to protect your Personal Information in our
                    possession, no method of transmission over the internet or
                    security system is perfect, and we cannot promise that
                    information about you will remain secure in all
                    circumstances.
                </p>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline py-1'}>
                    {' '}
                    Enquiries, Requests, or Concerns
                </p>
                <p className={'py-1'}>
                    All enquiries, requests, or concerns regarding this Privacy
                    Notice or relating to the processing of your Personal
                    Information including all requests as detailed in the “Your
                    rights” section above, should be sent to{' '}
                    <a
                        href="mailto: privacy@deshaw.com"
                        target="_blank"
                        className={'text-blue-800'}
                        rel="noreferrer"
                    >
                        privacy@deshaw.com
                    </a>
                    .
                </p>
            </div>
            <div className={'py-4'}>
                <p className={'font-bold underline'}>
                    {' '}
                    Changes to This Privacy Notice
                </p>
                <div className={'py-1'}>
                    We may update our Privacy Notice from time to time and will
                    post the date it was last updated at the top of this Privacy
                    Notice. When required under applicable law, we will provide
                    additional notice to you if we make any changes that affect
                    your privacy rights.
                </div>
            </div>
        </div>
    ),
};

export default PrivacyPolicy;
